<template>
  <div class="certification-page" v-loading="loading">
    <div class="title">经营资质</div>

    <div v-if="form.length > 0">
      <div class="line-box" v-for="(item,index) in form" :key="index">
        <div class="subtitle">{{ item.certificateName }}</div>
        <div class="content-box">
          <div class="name">
            资质内容：
          </div>
          <div class="content">
            {{ item.certificateNo }}
          </div>
        </div>
        <div class="content-box">
          <div class="name">
            授权委托人：
          </div>
          <div class="content">
            无
          </div>
        </div>
        <div class="content-box">
          <div class="name">
            失效时间：
          </div>
          <div class="content">
            {{ item.effectiveEndDate.split(" ")[0] }}
          </div>
        </div>
      </div>
    </div>
    <el-empty v-else description="暂无数据"></el-empty>
  </div>
</template>

<script>
import {getEnterprisesInfo} from "@/api/mycenter";

export default {
  name: "certification",
  beforeMount() {
    this.getEnterprisesInfo();
  },
  data() {
    return {
      loading: false,
      form: []
    }
  },
  methods: {
    getEnterprisesInfo() {
      this.loading = true;
      getEnterprisesInfo().then(result => {
        this.loading = false;
        if (result && result.code === "0") {
			if (result.data.qualifications) {
				this.form = result.data.qualifications.filter(item => item.qualificationType === "CERTIFICATE")
			}
        } else {
          this.$message({
            type: 'error',
            message: result.msg
          });
        }
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '出错了！'
        });
      })
    },
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import "@/assets/css/szui.scss";

.certification-page {
  padding: 30px 24px 30px;
  background: #FFFFFF;
  border-radius: 8px;

  .title {
    line-height: 1;
    font-size: 16px;
    font-weight: bold;
    color: #262728;
  }

  .line-box {
    margin-top: 20px;
    border: 1px solid #EDEFF2;
    border-radius: 10px;
    padding: 20px 24px 20px;

    .subtitle {
      font-size: 18px;
      font-weight: bold;
      color: #262728;
    }

    .content-box {
      margin-top: 20px;
      line-height: 1;
      display: flex;
      font-size: 14px;
      font-weight: 400;
      color: #606366;

      .name {
        width: 84px;
        margin-right: 30px;
        flex-shrink: 0;
        font-size: 14px;
        font-weight: 400;
        color: #606366;
      }

      .content {
        font-size: 14px;
        font-weight: 400;
        color: #262728;
      }
    }
  }


}
</style>